import * as Ably from "ably";
import { realtimeToken } from "../api/generated";

/** Sage's Ably channels. The API publishes on them; the browser can only subscribe. */
export const CHANNELS = {
  /** `task.upserted` (a Task) and `task.deleted` ({ id }). */
  tasks: "sage:tasks",
  /** `run.updated` (an AgentRun). */
  agentRuns: "sage:agent-runs",
  /** `blocks.replaced` ({ day }): that day's plan changed. */
  planning: "sage:planning",
} as const;

let client: Ably.Realtime | undefined;

/**
 * The shared Ably connection, opened the first time a page subscribes. It signs in with a token
 * request from `GET /realtime/token`, through the API client, so it needs the signed-in user's
 * token (set up by `ApiClientSetup`). Ably asks again when the token runs out.
 */
export function ably(): Ably.Realtime {
  client ??= new Ably.Realtime({
    authCallback: (_params, callback) => {
      realtimeToken({ throwOnError: true })
        .then(({ data }) => callback(null, data))
        .catch((error: { message?: string }) => callback(error.message ?? "Couldn't get a realtime token", null));
    },
  });
  return client;
}
